import { Dialog, Grid } from '@material-ui/core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RejectRecurringFileIcon } from '../../icons';
import {
  Container,
  Description,
  Detail,
  DetailContainer,
  StyledButton,
  TextareaWrapper,
  Title,
} from '../approve-enrollment-dialog/style';
import useViewModel from './viewmodel';

type RejectRecurringFileDialogProps = {
  open: boolean;
  batchName: string[];
  id: string[];
  onCancel?: () => void;
  onSubmit: (reason: string) => void;
};

const RejectRecurringFileDialog: FC<RejectRecurringFileDialogProps> = (
  props
) => {
  const { open, batchName, id, onCancel, onSubmit } = props;

  const { t } = useTranslation();

  const {
    reason,
    reasonLength,
    handleReasonChange,
    handleSubmit,
    handleCancel,
  } = useViewModel({
    onCancel,
    onSubmit,
  });

  return (
    <Dialog open={open}>
      <Container>
        <RejectRecurringFileIcon />
        <div>
          <Title>{t('dialog.reject_recurring_file')}</Title>
        </div>
        {batchName.length > 1 && (
          <Grid container>
            <Description>
              <span>{t('dialog.total_file', { files: id.length })}</span>
            </Description>
          </Grid>
        )}

        <DetailContainer>
          {batchName.map((item, index) => (
            <Detail key={id[index]} className="list">
              <span>{t('dialog.file')}</span>
              <span className="value">{item || '-'}</span>
            </Detail>
          ))}
        </DetailContainer>
        <TextareaWrapper>
          <textarea
            maxLength={100}
            placeholder={t('dialog.reason_placeholder')}
            value={reason}
            onChange={handleReasonChange}
          />
          <div className="textarea-char-count">{reasonLength}/100</div>
        </TextareaWrapper>

        <Grid container spacing={1}>
          <Grid item xs={6}>
            <StyledButton
              size="small"
              variant="outlined"
              onClick={handleCancel}
            >
              {t('dialog.cancel')}
            </StyledButton>
          </Grid>
          <Grid item xs={6}>
            <StyledButton
              color="primary"
              size="small"
              variant="contained"
              onClick={handleSubmit}
            >
              {t('dialog.confirm')}
            </StyledButton>
          </Grid>
        </Grid>
      </Container>
    </Dialog>
  );
};

export default RejectRecurringFileDialog;
